<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <h3 id="name" *ngIf="user_role.roles!=='student'">{{rows[0]?.userIds[0]?.name}}</h3>
                    <div class="card-body">

                        <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                            [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                            [offset]="page.offset" (page)="pageChangeData($event)">
                            <!-- <ngx-datatable-column name="Topic Name" prop="topic" [width]="100">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="d-flex align-items-center">
                                        <div class="cell-line-height cursor-pointer">
                                            <p class="font-medium-1 line-height-1 mb-0">
                                                {{ row?.topic[0]?.name }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column> -->
                            <ngx-datatable-column name="Class" prop="classId" [width]="80">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <p>{{row?.classId[0]?.title}}</p>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Refrences" prop="refrences" [width]="80">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <p>{{ row?.refrences?.links ? row.refrences.links : '--' }}</p>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Topics" prop="topics" [width]="80">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <span *ngFor="let item of row?.topics; last as isLast">
                                        {{item?.name}} <span>{{isLast ? '' : ','}}</span>
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Date" prop="date" [width]="20">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <p>{{row?.classId[0]?.date | date: 'mediumDate'}}</p>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Time" prop="time" [width]="40">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <p>{{row?.classId[0]?.start_time?row?.classId[0]?.start_time:'10:00'}} - {{row?.classId[0]?.end_time}}</p>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Attendance" [width]="50">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                <button *ngIf="user_role.roles==='student' && row?.attendance_status=='unconfirmed'" class="btn btn-outline-primary"
                                    (click)="openModal(row?._id)">
                                    Add Attendance
                                </button>
                                  <p  class="student-absent" *ngIf="user_role.roles==='student' && row?.attendance_status=='absent'">
                                    <img src="assets/student-absent-icon.svg" alt="absent-icon">
                                  </p>
                                  <p class="student-present"  *ngIf="user_role.roles==='student' && row?.attendance_status=='present'">
                                    <img src="assets/user-check.svg" alt="present-icon">
                                  </p>
                                </ng-template>
                              </ngx-datatable-column>
                              
                        </ngx-datatable>
                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div>
    <ng-template #myModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Add Attendance</h4>
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
        <form>
            <div class="form-group">
                <label>Attendance</label>
                <ng-select [items]="att_List" bindLabel="name" bindValue="id" placeholder="Select"
                    [(ngModel)]="selected_att" [ngModelOptions]="{ standalone: true }" (change)="getAttId($event)">
                </ng-select>
            </div>
            <div class="form-group">
                <label>Topic Name<span class="required_field">*</span></label>
                <ng-select [items]="topic_list" [multiple]="true" bindLabel="name" bindValue="_id" placeholder="Select topic"
                [(ngModel)]="select_topic" [multiple]="true" [ngModelOptions]="{ standalone: true }"
                [closeOnSelect]="false" (change)="getTopicId($event)">
            </ng-select>
            </div>
            <div class="form-group">
                <label>Feedback</label>
                <textarea name="feedback" id="feedback" class="form-control" cols="30" rows="2" [formControl]="feedback" placeholder="Type...."></textarea>
                <!-- <input type="text" class="form-control" [formControl]="feedback" > -->
            </div>
            <div class="form-group">
                <label>Private Feedback</label>
                <textarea name="feedback" id="feedback" class="form-control" cols="30" rows="2" [formControl]="privateFeedback" placeholder="Type...."></textarea>
                <!-- <input type="text" class="form-control" [formControl]="privateFeedback" > -->
            </div>
        </form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
            <button [disabled]="!select_topic" type="button" class="btn btn-primary" (click)="submit()">Submit</button>
        </div>
    </ng-template>
</div>
<div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>